<template>
  <ClientOverviewCard :title="$t('Finance overview')" :loading="loading" :loading-tiles="0">
    <WdsStack direction-column gap-md data-test="client-payments-card">
      <div class="tw-grid tw-grid-cols-3 tw-gap-4">
        <WdsText class="tw-font-large">
          <span class="tw-text-gray-900">{{ $t('Invoice cadence') }}</span>
        </WdsText>
        <div class="tw-col-span-2" data-test="client-payments-cadence">
          <ClientInvoiceCadenceLabel
            :cadence="client?.invoiceBatchingCadence ?? null"
            :follows-client="client?.invoiceBatchingCadenceFollowsClient ?? false"
          />
        </div>

        <WdsText class="tw-font-large">
          <span class="tw-text-gray-900">{{ $t('Payment terms') }}</span>
        </WdsText>
        <div class="tw-col-span-2" data-test="client-payments-terms">
          <ClientPaymentTermsLabel
            :days="client?.paymentTerm ?? null"
            :method="client?.paymentTermMethod ?? null"
            :follows-client="client?.paymentTermsFollowsClient ?? false"
          />
        </div>
      </div>
    </WdsStack>
  </ClientOverviewCard>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { WdsStack, WdsText } from '@worksome/wds-components'
import { FragmentType, graphql, useFragment } from '@/gql'
import { $t } from '@/app-bootstrapping/SetUpInternationalization'
import ClientOverviewCard from '@/components/Clients/OverviewCards/ClientOverviewCard.vue'
import ClientPaymentTermsLabel from '@/components/Clients/ClientPaymentTermsLabel.vue'
import ClientInvoiceCadenceLabel from '@/components/Clients/ClientInvoiceCadenceLabel.vue'

const ClientPaymentsCardFields = graphql(`
  fragment ClientPaymentsCard on CompanySupplier {
    id
    paymentTermsFollowsClient
    invoiceBatchingCadenceFollowsClient
    paymentTerm
    paymentTermMethod
    invoiceBatchingCadence {
      enabled
      intervalWeeks
      weekday
    }
  }
`)

const props = defineProps<{
  client: FragmentType<typeof ClientPaymentsCardFields> | null
  loading: boolean
}>()

const client = computed(() => useFragment(ClientPaymentsCardFields, props.client ?? null) ?? null)
</script>
